import { useHttp } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'

export const useLoadEvents = (data: any, object_id: Ref<number | string>) => {
  const http = useHttp()

  const url = computed(() => {
    const searchParams = new URLSearchParams(data)
    return `/notifications?${searchParams}`
  })

  const queryKey = computed(() => ['events', object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
    enabled: false,
  })
}
